import type { StaticDataRouteOption } from "@tanstack/react-router"

import { AppNavigation } from "../NavigationView/AppNavigation"
import { ReportsViewTopBar } from "./TopBar"

export const reportsViewLayoutHandle: StaticDataRouteOption = {
	leftSlideOut: AppNavigation,
	topBar: ReportsViewTopBar,
}
